import { IpotekaLinkButton } from '../../../components/QuizCompleted';

export const extraBtnsMap = {
  mortgage: IpotekaLinkButton,
};
